<template>
  <section id="HeaderBackground" class="headerBackground">
    <div class="header-content">
      <parallax :speed-factor="0.5">
        <div class="header-content-inner">
          <img src="../assets/blueMoon-min.png" alt="moon" id="moon" class="moon">
          <img
            src="../assets/skearLogo2020LueurExterne-min.png"
            alt="site logo"
            id="skear"
            class="skearLogo"
          >
          <h1 class="homeHeading">SKEAR</h1>
        </div>
      </parallax>
    </div>
  </section>
</template>

<script>
import Parallax from "vue-parallaxy";

export default {
  name: "HeaderBackground",
  components: {
    Parallax
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.headerBackground {
  position: relative;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
  //background-image: linear-gradient(0.25turn, #00b2ff21, #00248a4d, #ff840000), url(../assets/background/moon_horizon3.jpg);
  @media (max-width: 1920px) { 
    background-image: url(../assets/background/moon_horizon3_1k.jpg);
  }
  background-image: url(../assets/background/moon_horizon3_2k.jpg);
  text-align: center;
  color: white;
  .header-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    width: 100%;
    .header-content-inner {
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
      transform: translateY(50%);
      .skearLogo {
        width: 260px;
      }
      .moon {
        position: absolute;
        z-index: -1;
        width: 260px;
        transform: translateX(42px) translateY(-61px);
      }
      .homeHeading {
        font-size: 50px;
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 0;
        margin-bottom: 0;
        font-family: "Orbitron", sans-serif;
        text-shadow: #aba5ff 1px 0 10px;
        letter-spacing: 22px;
        margin-left: 60px;
      }
      .home-description {
        font-size: 18px;
        max-width: 80%;
        margin-left: auto;
        margin-right: auto;
        font-weight: 300;
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 50px;
        line-height: 1.5;
      }
    }
  }
}
</style>
